import { render, staticRenderFns } from "./polaris-checkbox.vue?vue&type=template&id=76e0dda4&"
import script from "./polaris-checkbox.vue?vue&type=script&lang=js&"
export * from "./polaris-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports